import { createAsyncThunk } from "@reduxjs/toolkit";
import { AdvertisePackage } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindAdvertisePackage, GetAdvertisePackage } from "../../advertisePackage/api/interface";

export const findSelectAdvertisePackage = createAsyncThunk(
  "selectAdvertisePackage/findSelectAdvertisePackage",
  async (values: FindAdvertisePackage, { rejectWithValue }) => {
    try {
      const response = await AdvertisePackage.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectAdvertisePackage = createAsyncThunk(
  "selectAdvertisePackage/searchSelectAdvertisePackage",
  async (values: FindAdvertisePackage, { rejectWithValue }) => {
    try {
      const response = await AdvertisePackage.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectAdvertisePackage = createAsyncThunk(
  'selectAdvertisePackage/getSelectAdvertisePackage',
  async ({ id }: GetAdvertisePackage, { rejectWithValue }) => {
    try {
      const response = await AdvertisePackage.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
